import { useTechDeviceState } from "../../core/TechLive"
import Icon from "../base/Icon"
import { locationWords } from "./TechDeviceWords"

interface IProps {
    techId?: string
    className?: string
    /** Where a row already carries its own icon. */
    noIcon?: boolean
    /** Just the answer, without "Location access:" — for the map's panel, where the icon says it. */
    compact?: boolean
}

/**
 * What the technician's phone allows with location — "Always", "While Using", "Off" — on the
 * map's panel and drawer, beside how fresh the dot is. "On the clock" only means "on the map"
 * when this says Always.
 */
export default function TechLocationAccessLabel(props: IProps) {

    const state = useTechDeviceState(props.techId)
    const words = state?.locationStatus ? locationWords[state.locationStatus] : undefined

    return (
        <span className={`d-inline-flex align-items-center ${props.className ?? ""}`}
            title={words?.note ?? "Their phone has not reported its location access yet."}>
            {/* In a column as wide as the status dots on the lines around it, centred, so the
                icon lines up with them instead of standing out to the right. */}
            {!props.noIcon &&
                <span className="d-inline-flex justify-content-center me-2" style={{ width: 7, overflow: "visible" }}>
                    <Icon icon="location-crosshairs" className={`text-${words?.tone ?? "gray-500"}`} size={11} />
                </span>
            }
            {!props.compact && <span className="text-gray-600 me-1">Location access:</span>}
            <span className={`fw-semibold text-${words?.tone ?? "gray-500"}`}>
                {words?.label ?? "Not reported"}
                {state?.locationPrecise === false && words && state.locationStatus !== "denied" && " (approximate)"}
            </span>
        </span>
    )
}
